<template>
	<BaseLayout
		class="home-view-wrapper"
		background-color-class="bg-color-greige"
		:include-padding="false"
		:transparent-header="true"
		:transparent-header-dark-text="true"
	>
		<div class="marketing-site-home" role="main">
			<HomepageHero
				:loading="loading"
				:show-lead-capture="true"
				micro-copy="Sign up to get your custom portfolio recommendation"
				:lead-capture-config-override="leadCaptureConfigOverride"
				:is-in-hero-copy-test="isInHeroCopyTest"
			/>
			<HomepageContent />
		</div>

		<template #footer>
			<FooterSocialStats />
		</template>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from 'vue';
import FooterSocialStats from '@components/footer/footer-home-page.vue';
import HomepageContent from '@components/marketing-site/homepage-content.vue';
import HomepageHero from '@components/marketing-site/homepage-hero.vue';
import { LeadCaptureFormConfig } from 'types/layout/lead';
import { useHead } from '@unhead/vue';
import { useSessionStorage } from '@vueuse/core';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';

const thirdPartyAuthStore = useThirdPartyAuthStore();
thirdPartyAuthStore.disable(onBeforeUnmount);

const loading = ref(false);
const isInHeroCopyTest = useSessionStorage('isInHeroCopyTest', false);

const leadCaptureConfigOverride = computed((): LeadCaptureFormConfig => {
	return {
		buttonText: 'Get started',
		textCssClass: 'body-lg homepage-button-copy-test',
		signupFlowType: 'STANDARD',
		buttonClass: `button-primary lead-capture__button-primary`
	};
});

useHead({
	title: null,
	link: [
		{
			rel: 'preload',
			as: 'image',
			href: '/media/marketing-site/homepage-hero.webp',
			fetchpriority: 'high'
		}
	]
});
</script>

<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.home-view-wrapper {
	overflow-x: hidden;
}
</style>
